import yaml from 'js-yaml'
export default yaml.load(`

- prize: "Winner: Impact Awards"
  competition: MIT Breaking the Mold Hackathon
  pressLink: "https://twitter.com/dearanzeta/status/835668565701308416"
  time: February 2017
  role: UX/UI Designer
  with: "Team Superfriend"

- prize: 1st Runner-up
  competition: LINE Hackathon Thailand 2016
  pressLink: "https://facebook.com/Thailand.Line/posts/1345984965417856:0"
  time: April 2016
  role: UX/UI Designer
  with: "Team Rollables"

- prize: One of the six qualified teams
  competition: LINE Private Hackathon Thailand 2016 sponsored by a brand 
  time: June 2016
  role: UX/UI Designer
  with: "Team Rollables"

- prize: "Winner: Gold Awards"
  competition: Samart Innovation Awards 2012
  pressLink: "http://www.bangkokpost.com/learning/advanced/284202/mobile-phones-flexible-hotel-pricing"
  time: March 2012
  role: Frontend Developer
  with: "Team Newline"
  
- prize: Finalist
  competition: National Electronics and Computer Technology Center (NECTEC) National Software Contest 2011
  time: Febuary 2011
  role: Developer
  with: "Decha Muangsri"

- prize: 2nd Runner-up
  competition: National Electronics and Computer Technology Center (NECTEC) National Software Contest 2004
  time: June 2004

- prize: 1st Class Honors
  competition: Bachelor of Engineering (Computer Engineering)
  organization: Chulalongkorn University
  time: March 2012
`)


/** WEBPACK FOOTER **
 ** ../data/awards.js
 **/